<label [for]="filterId + '-comparison'">{{ label }}</label>
<div class="date-filter-controls">
  <select class="form-control comparison-select" [id]="filterId + '-comparison'"
    [attr.aria-label]="'Phép so sánh ' + label.toLowerCase()" [ngModel]="comparison"
    (ngModelChange)="selectComparison($event)">
    <option value="<">Trước ngày</option>
    <option value="=">Trong ngày</option>
    <option value=">">Sau ngày</option>
  </select>

  <div class="date-picker">
    <div class="dp-hidden position-absolute custom-dp-dropdown">
      <input class="form-control" ngbDatepicker #datepicker="ngbDatepicker"
        [autoClose]="'outside'" [displayMonths]="1" [dayTemplate]="dayTemplate"
        [footerTemplate]="footerTemplate" outsideDays="hidden"
        [minDate]="{ year: 2, month: 1, day: 1 }" [maxDate]="{ year: 9998, month: 12, day: 31 }"
        [ngModel]="date" (dateSelect)="selectDate($event)" [name]="filterId + '-picker'"
        tabindex="-1" aria-hidden="true" readonly />
    </div>

    <div class="input-group custom-dt-picker">
      <input type="text" class="form-control" [id]="filterId + '-date'" placeholder="yyyy-mm-dd"
        [value]="formatter.format(date!)" [attr.aria-label]="label"
        (click)="datepicker.toggle()" readonly />
      <button type="button" class="btn btn-outline-secondary" (click)="datepicker.toggle()"
        [attr.aria-label]="'Mở lịch ' + label.toLowerCase()" [attr.aria-expanded]="datepicker.isOpen()">
        <i class="ri-calendar-line" aria-hidden="true"></i>
      </button>
    </div>

    <ng-template #dayTemplate let-day let-today="today">
      <span class="custom-day" [class.range]="day.equals(date)"
        [attr.aria-current]="today ? 'date' : null">{{ day.day }}</span>
    </ng-template>

    <ng-template #footerTemplate>
      <hr class="my-0" />
      <button type="button" class="btn btn-primary btn-sm m-2 float-start"
        (click)="selectDate(null); datepicker.close()">Clear</button>
      <button type="button" class="btn btn-secondary btn-sm m-2 float-end"
        (click)="datepicker.close()">Close</button>
    </ng-template>
  </div>
</div>
